import { Faq } from "core/models/Faq";

const faqItems: Faq[] = [
    {
        id: 0,
        question: "How do I create a clip?",
        answer: "You can create a clip by clicking on live stream on the toolbar on the left side. Select the live stream where you want to create a clip from. Once you have selected the live stream, select the content you wish to create a clip from, by choosing the correct in and out moment (left and right sides of the thumbnails). After that, all there’s left to do is click on ‘create clip’.",
    },
    {
        id: 1,
        question: "How do I connect my live stream?",
        answer: "You can easily connect your live stream yourself through the ‘Connect live stream’ button within the Livestreams page. You’ll have the ability to either directly input your stream’s HLS URL, or request an RTMP Endpoint from us for you to stream towards. If you need more than 1 live stream or require a different method of connecting, please get in touch.",
    },
    {
        id: 2,
        question:
            "What are the technical requirements of the live streams you support?",
        answer: "We support HLS (push + pull, multiplexed preferred), RTMP (push) and RTSP (push) for the resolutions of 720p and/or 1080p up to 4096 * 2048 (4k, 2160p is not supported). Video format should be H.264, the Audio format should be AAC, and B-Frames are allowed. The maximum frames per second is 60, anything below is supported. For best results, the audio delay should be minimal in the MPEG-TS stream and the audio has to be in the same MPEG-TS fragments as the video The fragments should match the MPEG-TS norm. Open GOP must be off.",
    },
    {
        id: 3,
        question: "What if I have more than 1 live stream?",
        answer: "If you need multiple connected live streams, please get in touch with us to help set you up.",
    },
    {
        id: 4,
        question: "Can I watch my incoming stream?",
        answer: "Yes! You can watch your live stream whilst working. Once you’ve selected the live stream that you’re working in press on watch live and your live stream will start playing.",
    },
    {
        id: 5,
        question: "How long is my stream recorded for?",
        answer: "Your stream will be recorded for 24 hours. Meaning you can create clips from yesterday’s live stream. If you need a longer recording window, please get in touch.",
    },
    {
        id: 6,
        question: "My stream shows it is offline, what do I do?",
        answer: "This means we can not validate your stream coming in as we continuously try to ingest your stream. Check with your source whether everything is still set up correctly and is streaming towards us, or is available for fetching.",
    },
    {
        id: 7,
        question:
            "How can I add my media files to use as intros, outros, or overlays?",
        answer: "In the toolbar at the left side select settings. In settings click on Addons and then on Add addon. Give your addon a name, select the type of addon (Intro, outro, or overlay) and upload your file. You can now use this addon for your clips.",
    },
    {
        id: 8,
        question: "Can I use this tool with my team?",
        answer: "Yes! You can use the tool with your team. It is possible to create the users with the right permissions yourself. If you want to add users, navigate to settings in the toolbar on the left side. Click on Users & Permissions and click on Add User.",
    },
    {
        id: 9,
        question: "How much does the tool cost?",
        answer: "We offer different packages with different prices, so check out our plans page to see what suits you best.",
    },
    {
        id: 10,
        question: "How long are my clips stored?",
        answer: "By default, we’ll store your clips for 30 days, if you need them stored any longer, please get in touch.",
    },
    {
        id: 11,
        question: "How do I crop a clip?",
        answer: "Within the clips page, on the clip you wish to crop; Hover over the ‘pencil’ icon and select ‘Edit clip’. Start by choosing the aspect ratio you would like to give to your clip. Click on crop and select the part of the clip you would like to keep. Once done click on create.",
    },
    {
        id: 12,
        question: "How do I resize my clip?",
        answer: "Within the clips page, on the clip you wish to crop; Hover over the ‘pencil’ icon and select ‘Edit clip’. Start by choosing the aspect ratio you would like to give to your clip. Click on resize. Once done click on create.",
    },
    {
        id: 13,
        question: "How do I trim a clip?",
        answer: "Within the clips page, on the clip you wish to crop; Hover over the ‘pencil’ icon and select ‘Edit clip’. Underneath your video, you’ll see a play bar with trim handles on either side, by dragging these handles you can determine how much content has to be trimmed off at either the beginning or the end. ",
    },
    {
        id: 14,
        question: "How to add an intro to my clip",
        answer: "In the toolbar on the left side select clips. Find the clip you would like to add an intro to and hover over the ‘pencil’ icon and select ‘Edit clip’.  Select the intro you want to add to the clip (choose from previously added intros for this clip’s aspect ratio). All there is left to do is click on create.",
    },
    {
        id: 15,
        question: "How to add an outro to my clip",
        answer: "In the toolbar on the left side select clips. Find the clip you would like to add an outro to and hover over the ‘pencil’ icon and select ‘Edit clip’.  Select the outro you want to add to the clip (choose from previously added outros for this clip’s aspect ratio). All there is left to do is click on create.",
    },
    {
        id: 16,
        question: "How to add an overlay (logo) to my clip",
        answer: "In the toolbar on the left side select clips. Find the clip you would like to add an overlay to and hover over the ‘pencil’ icon and select ‘Edit clip’.  Select the overlay you want to add to the clip (choose from previously added overlays for this clip’s aspect ratio). All there is left to do is click on create.",
    },
    {
        id: 17,
        question: "How do I create a compilation",
        answer: "In the toolbar on the left side select clips. Click on Compilation on the top right corner and select the clips you want to add to your compilation. In the order you select them, they’ll be stitched together.",
    },
    {
        id: 18,
        question: "How do I share to Twitter",
        answer: "Start by connecting the correct Twitter account through the Settings page. After that, find the clip you would like to share and click on the share-arrow with it. Select Twitter and write your tweet.",
    },
    {
        id: 19,
        question: "How do I share to YouTube",
        answer: "Start by connecting the correct YouTube account through the Settings page. After that, find the clip you would like to share and then click on the arrow. Select YouTube and write your post.",
    },
    {
        id: 20,
        question: "How do I share to Facebook",
        answer: "Start by connecting the correct Facebook account through the Settings page. After that, find the clip you would like to share and then click on the arrow. Select YouTube and write your post.",
    },
    {
        id: 21,
        question: "Can I also share to other social media platforms?",
        answer: "Yes! You can do so by downloading your clip and uploading it to the social media platform of your choice, or by using our mobile app which lets you natively share anywhere.",
    },
    {
        id: 22,
        question:
            "Can I also publish my clips to other platforms than social media, such as my own CMS?",
        answer: "Yes, we offer custom integrations with your platforms, get in touch to discuss the possibilities",
    },
    {
        id: 23,
        question: "I have a feature request, can I submit this somewhere?",
        answer: "For a feature you can always send us an email and we’ll get back to you a.s.a.p..",
    },
    {
        id: 24,
        question: "Can I also use SpotOn with pre-existing content?",
        answer: "Yes, simply upload the videos from your system through the ‘upload’ functionality if it’s in your plan.",
    },
    {
        id: 25,
        question: "How long can my created clips be?",
        answer: "You can create clips of up to 30 or 60 minutes, depending on your plan.",
    },
    {
        id: 26,
        question: "Can I also export my clips in a different format?",
        answer: "You can export clips created with SpotOn in the following formats: MP3, MP4 and GIF.",
    },
];
export default faqItems;
